// Wrap everything to avoid conflicts
(function () {
  'use strict';

  async function addVariant({ id, quantity = 1 }) {
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [
            {
              id: id,
              quantity: quantity,
              selling_plan: null,
              properties: null,
            },
          ],
        }),
      });

      const data = await response.json();
      if (data.items && data.items.length > 0) {
        const cartResponse = await fetch(window.Shopify.routes.root + 'cart.json');
        const cartData = await cartResponse.json();
        const mainStore = Alpine.store('main');
        if (mainStore) {
          mainStore.cart = cartData;
          mainStore.isMiniCartOpen = true;
        }
      } else if (data.description) {
        alert(data.description);
        throw new Error(data.description);
      }
    } catch (error) {
      console.error('Error adding variant:', error);
    }
  }

  // Track if handler is already attached to prevent duplicates
  let handlerAttached = false;

  // Use window to track globally across script executions
  function attachAddToCartHandler() {
    if (window.__addToCartHandlerAttached) {
      console.log('Add to cart handler already attached');
      return;
    }

    window.__addToCartHandlerAttached = true;

    // Use event delegation on document
    document.addEventListener(
      'click',
      function (event) {
        const button = event.target.closest('button.addVariantButton');

        if (button) {
          event.preventDefault();
          event.stopPropagation();

          const variantId = button.dataset.variantId || button.getAttribute('data-variant-id');

          if (!variantId) {
            console.error('No variant ID found on button:', button);
            return;
          }

          console.log('Adding variant:', variantId);

          addVariant({
            id: variantId,
            quantity: 1,
          });
        }
      },
      { capture: true },
    );

    console.log('Add to cart handler attached');
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachAddToCartHandler);
  } else {
    attachAddToCartHandler();
  }
})();
